import { eventService, groupHomeService } from 'srcReact/services'
import { mediaConstants as mc } from './constants'

export const mediaActions = {
  getPictures,
  getLinks,
  getDocuments
}

const defaultQuantity = 10
function getPictures(type, id, pagination, quantity = defaultQuantity) {
  const { nextOffset, isPagination } = pagination
  return (dispatch) => {
    dispatch(request(isPagination, id, nextOffset))
    if (type === 'group') {
      groupHomeService.getMedia(id, 'pictures_media', nextOffset, quantity).then(
        (response) => {
          dispatch(success(response, type))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
    } else if (type === 'mixr') {
      eventService.getMedia(id, 'pictures_media', nextOffset, quantity).then(
        (response) => {
          dispatch(success(response, type))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
    }
  }

  function request(isPagination, id, nextOffset) {
    return { type: mc.GET_PICTURES_REQUEST, isPagination, id, nextOffset }
  }
  function success(response, type) {
    const updatedResponse = { ...response, isPagination, type }
    return { type: mc.GET_PICTURES_SUCCESS, updatedResponse }
  }
  function failure(error) {
    return { type: mc.GET_PICTURES_FAILURE, error }
  }
}

function getLinks(type, id, pagination, search, quantity = defaultQuantity) {
  const { nextOffset, isPagination } = pagination
  return (dispatch) => {
    dispatch(request(isPagination))
    if (type === 'group') {
      groupHomeService.getMedia(id, 'shared_links', nextOffset, quantity, search).then(
        (response) => {
          dispatch(success(response, type))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
    } else if (type === 'mixr') {
      eventService.getMedia(id, 'shared_links', nextOffset, quantity, search).then(
        (response) => {
          dispatch(success(response, type))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
    }
  }

  function request(isPagination) {
    return { type: mc.GET_LINKS_REQUEST, isPagination }
  }
  function success(response, type) {
    const updatedResponse = { ...response, isPagination, type }
    return { type: mc.GET_LINKS_SUCCESS, updatedResponse }
  }
  function failure(error) {
    return { type: mc.GET_LINKS_FAILURE, error }
  }
}

function getDocuments(type, id, pagination, search, filter, quantity = defaultQuantity) {
  const { nextOffset, isPagination } = pagination
  return (dispatch) => {
    dispatch(request(isPagination))
    if (type === 'group') {
      groupHomeService.getMedia(id, 'documents_media', nextOffset, quantity, search, filter).then(
        (response) => {
          dispatch(success(response, type))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
    } else if (type === 'mixr') {
      eventService.getMedia(id, 'documents_media', nextOffset, quantity, search, filter).then(
        (response) => {
          dispatch(success(response, type))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
    }
  }

  function request(isPagination) {
    return { type: mc.GET_DOCUMENTS_REQUEST, isPagination }
  }
  function success(response, type) {
    const updatedResponse = { ...response, isPagination, type }
    return { type: mc.GET_DOCUMENTS_SUCCESS, updatedResponse }
  }
  function failure(error) {
    return { type: mc.GET_DOCUMENTS_FAILURE, error }
  }
}
